import React, { useMemo, useState } from "react";
import { Form, Switch, TextArea, TextEditor, Icon, Tooltip } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";

export const NOTIFICATION_TEXT_CONTENT_MAX_LENGTH = 150;

export const TextContent = ({
  notification,
  isEditMode,
  isHidden
}: INotificationField) => {
  const { t } = useTranslation();
  const [isHTMLPreview, setIsHTMLPreview] = useState(false);

  const isPushNotification = useMemo<boolean>(() => {
    return notification?.Provider === "FIREBASE";
  }, [notification?.Provider]);
  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      label={
        <span>
          {t("NOTIFICATION_TEXT_CONTENT_FIELD")}&nbsp;
          <Tooltip title="Camp no obligatori: tot i que no serà habitual, la notificació es pot voler enviar sense descripció. Aquest camp té un límit màxim de 150 caràcters. Cal anar amb compte, ja que en seleccionar l'emplenament automàtic, si el contingut supera els 150 caràcters es trunca automàticament fins a aquest màxim.">
            <Icon type="question-circle" />
          </Tooltip>
        </span>
      }
    >
      {!isPushNotification && (
        <Form.Item>
          <Switch
            checkedChildren={t("NOTIFICATION_HTML_ON_FIELD")}
            unCheckedChildren={t("NOTIFICATION_HTML_OFF_FIELD")}
            onChange={setIsHTMLPreview}
            defaultChecked={isHTMLPreview}
          />
        </Form.Item>
      )}
      <Form.Item
        name="TextContent"
        key="TextContent"
        initialValue={isEditMode ? notification?.TextContent : ""}
      >
        {!isHTMLPreview && !isPushNotification || notification?.Provider === "FIREBASE" ? (
          <TextArea
            rows={5}
            placeholder={t("NOTIFICATION_TEXT_CONTENT_INPUT_FIELD")}
            maxLength={NOTIFICATION_TEXT_CONTENT_MAX_LENGTH}
            showCount
          />
        ) : (
          <TextEditor addImage={false} />
        )}
      </Form.Item>
    </Form.Item>
  );
};
